// eventDefinitions.ts
export var EventName;
(function (EventName) {
    EventName["HOME_PAGE_VIEW"] = "Home Page View";
    EventName["ABOUT_PAGE_VIEW"] = "About Page View";
    EventName["MANIFESTO_PAGE_VIEW"] = "Manifesto Page View";
    EventName["FOR_ARTIST_PAGE_VIEW"] = "For Artist Page View";
    EventName["TERMS_PAGE_VIEW"] = "Terms Page View";
    EventName["ARTIST_TERMS_PAGE_VIEW"] = "Artist Terms Page View";
    EventName["COMMON_TERMS_PAGE_VIEW"] = "Common Terms Page View";
    EventName["TICKETS_HOST_TERMS_PAGE_VIEW"] = "Tickets Host Terms Page View";
    EventName["TICKETS_BUYER_TERMS_PAGE_VIEW"] = "Tickets Buyer Terms Page View";
    EventName["TICKETS_REFUND_POLICY_PAGE_VIEW"] = "Tickets Refund Policy Page View";
    EventName["LEGAL_INDEX_PAGE_VIEW"] = "Legal Index Page View";
    EventName["PRIVACY_PAGE_VIEW"] = "Privacy Page View";
    EventName["TRUST_PAGE_VIEW"] = "Trust Page View";
    EventName["CONTACT_PAGE_VIEW"] = "Contact Page View";
    EventName["PRINCIPLES_PAGE_VIEW"] = "Principles Page View";
    EventName["PUBLIC_SHARED_CORAL_VIEW"] = "Public Shared Coral View";
    EventName["PUBLIC_ARTIST_VIEW"] = "Public Artist View";
    EventName["VIEW_ALL_CONTRIBUTIONS_INTERACTION"] = "View All Contributions Interaction";
    EventName["FAQ_ITEM_VIEWED"] = "FAQ Item Viewed";
    EventName["COLLECTIVE_CALCULATOR_INTERACTION"] = "Collective Calculator Interaction";
    EventName["COLLECTIVE_TABLE_INTERACTION"] = "Collective Table Interaction";
    EventName["USER_ACCOUNT_CREATED"] = "User Account Created";
    EventName["USER_PROFILE_SETUP"] = "User Profile Setup";
    EventName["DASHBOARD_PAGE_VIEW"] = "Dashboard Page View";
    EventName["OUR_IMPACT_PAGE_VIEW"] = "Our Impact Page View";
    EventName["ARTIST_NOT_FOUND"] = "Artist Not Found";
    EventName["ARTIST_PROFILE_GENERATION"] = "Artist Profile Generation";
    EventName["ARTIST_PROFILE_URL_COPIED"] = "Artist Profile URL Copied";
    EventName["ARTIST_PROFILE_QR_CODE_DOWNLOADED"] = "Artist Profile QR Code Downloaded";
    EventName["ARTIST_BRAND_KIT_DOWNLOADED"] = "Artist Brand Kit Downloaded";
    EventName["BRANDED_IMAGE_VIEWED"] = "Branded Image Viewed";
    EventName["BRANDED_IMAGE_DOWNLOADED"] = "Branded Image Downloaded";
    EventName["ARTIST_CONNECTION_MADE"] = "Artist Connection Made";
    EventName["ARTIST_VERIFICATION_PAGE_VIEW"] = "Artist Verification Page View";
    EventName["ARTIST_VERIFICATION_SUBMITTED"] = "Artist Verification Submitted";
    EventName["IDENTIFICATION_PAGE_VIEW"] = "Identification Page View";
    EventName["IDENTIFICATION_SUBMITTED"] = "Identification Submitted";
    EventName["ARTIST_VERIFICATION_VIEW"] = "Artist Verification View";
    EventName["ARTIST_VERIFICATION_COMPLETE"] = "Artist Verification Complete";
    EventName["CREATE_CORAL_STARTED"] = "Create Coral Started";
    EventName["CORAL_CREATION_METHOD"] = "Coral Creation Method";
    EventName["CREATE_CORAL_SAVED"] = "Create Coral Saved";
    EventName["CREATE_CORAL_GOTO_PAYMENT"] = "Create Coral Goto Payment";
    EventName["CREATE_CORAL_COMPLETED"] = "Create Coral Completed";
    EventName["ADD_ARTIST_TO_CORAL"] = "Add Artist to Coral";
    EventName["REMOVE_ARTIST_FROM_CORAL"] = "Remove Artist from Coral";
    EventName["SIMULATE_CORAL"] = "Simulate Coral";
    EventName["BOOST_ARTIST_IN_CORAL"] = "Boost Artist in Coral";
    EventName["UPDATE_CORAL_NAME"] = "Update Coral Name";
    EventName["SHARE_CORAL"] = "Share Coral";
    EventName["CORAL_PLEDGE_AMOUNT_CHANGED"] = "Coral Pledge Amount Changed";
    EventName["CORAL_ARTIST_ADDED"] = "Coral Artist Added";
    EventName["CORAL_ARTIST_REMOVED"] = "Coral Artist Removed";
    EventName["CORAL_ARTIST_PINNED"] = "Coral Artist Pinned";
    EventName["CORAL_ARTIST_UNPINNED"] = "Coral Artist Unpinned";
    EventName["CORAL_FEES_EXPANDED"] = "Coral Fees Expanded";
    EventName["CORAL_FEES_COLLAPSED"] = "Coral Fees Collapsed";
    EventName["CORAL_GOTO_PAYMENT"] = "Coral Go to Payment";
    EventName["CORAL_CREATION_COMPLETED"] = "Coral Creation Completed";
    EventName["MUSIC_URL_RESOLVED"] = "Music URL Resolved";
    EventName["MUSIC_CONTENT_SHARED"] = "Music Content Shared";
    EventName["PERSONAL_POST_STARTED"] = "Personal Post Started";
    EventName["PERSONAL_POST_CREATED"] = "Personal Post Created";
    EventName["GESTURE_CREATED"] = "Gesture Created";
    EventName["NEWSLETTER_SIGNUP"] = "Newsletter Signup";
    // --- Coral Tickets (tickets-frontend) ---
    // Visitor
    EventName["TICKETS_HOME_PAGE_VIEW"] = "Tickets Home Page View";
    EventName["TICKETS_EVENT_PAGE_VIEW"] = "Tickets Event Page View";
    EventName["TICKETS_HOST_PROFILE_PAGE_VIEW"] = "Tickets Host Profile Page View";
    EventName["TICKETS_DEMO_FEE_ARTIST_SELECTED"] = "Tickets Demo Fee Artist Selected";
    // Buyer funnel
    EventName["TICKETS_TICKET_SELECTOR_OPENED"] = "Tickets Ticket Selector Opened";
    EventName["TICKETS_HOLD_CREATED"] = "Tickets Hold Created";
    EventName["TICKETS_HOLD_FAILED"] = "Tickets Hold Failed";
    EventName["TICKETS_HOLD_EXPIRED"] = "Tickets Hold Expired";
    EventName["TICKETS_CHECKOUT_STARTED"] = "Tickets Checkout Started";
    EventName["TICKETS_CHECKOUT_DETAILS_SUBMITTED"] = "Tickets Checkout Details Submitted";
    EventName["TICKETS_PURCHASE_COMPLETED"] = "Tickets Purchase Completed";
    EventName["TICKETS_PAYMENT_OUTCOME"] = "Tickets Payment Outcome";
    // Wallet quick-pay funnel (event page): shown is the denominator (fires per wallet the SDK
    // deemed eligible), tapped/authorized are the steps, failed carries the refusal reason.
    EventName["TICKETS_WALLET_ELIGIBLE_SHOWN"] = "Tickets Wallet Eligible Shown";
    EventName["TICKETS_QUICKPAY_TAPPED"] = "Tickets Quickpay Tapped";
    EventName["TICKETS_QUICKPAY_AUTHORIZED"] = "Tickets Quickpay Authorized";
    EventName["TICKETS_QUICKPAY_FAILED"] = "Tickets Quickpay Failed";
    EventName["TICKETS_FEE_ARTIST_SELECTED"] = "Tickets Fee Artist Selected";
    EventName["TICKETS_THANKS_VIEWED"] = "Tickets Thanks Viewed";
    EventName["TICKETS_PICKER_GENRE_SELECTED"] = "Tickets Picker Genre Selected";
    EventName["TICKETS_PICKER_ARTIST_SEARCHED"] = "Tickets Picker Artist Searched";
    EventName["TICKETS_PICKER_ELIGIBILITY_OPENED"] = "Tickets Picker Eligibility Opened";
    // The confirmation page's Coral opt-in: shown is the denominator, tapped the step, confirmed the
    // server's yes, failed the rest.
    EventName["TICKETS_CORAL_OPTIN_SHOWN"] = "Tickets Coral Optin Shown";
    EventName["TICKETS_CORAL_OPTIN_TAPPED"] = "Tickets Coral Optin Tapped";
    EventName["TICKETS_CORAL_OPTIN_CONFIRMED"] = "Tickets Coral Optin Confirmed";
    EventName["TICKETS_CORAL_OPTIN_FAILED"] = "Tickets Coral Optin Failed";
    // Auth
    EventName["TICKETS_ACCOUNT_CREATED"] = "Tickets Account Created";
    EventName["TICKETS_SIGNED_IN"] = "Tickets Signed In";
    // Host funnel
    EventName["TICKETS_HOST_ONBOARDING_STARTED"] = "Tickets Host Onboarding Started";
    /**
     * The person's own details failed to save during host onboarding. Deliberately non-blocking —
     * onboarding continues and the host still gets an organiser — so this is the only signal that
     * the write is failing at all. A rising rate means hosts are landing without names.
     */
    EventName["TICKETS_HOST_PERSON_DETAILS_FAILED"] = "Tickets Host Person Details Failed";
    EventName["TICKETS_ORGANISER_CREATED"] = "Tickets Organiser Created";
    EventName["TICKETS_CREATE_EVENT_STARTED"] = "Tickets Create Event Started";
    EventName["TICKETS_EVENT_DRAFT_CREATED"] = "Tickets Event Draft Created";
    EventName["TICKETS_EVENT_PUBLISHED"] = "Tickets Event Published";
    EventName["TICKETS_ADVANCED_OPENED"] = "Tickets Advanced Opened";
    // Add more events as needed
})(EventName || (EventName = {}));
